(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CompendiumSpecialPriceSearch', CompendiumSpecialPriceSearch);

    CompendiumSpecialPriceSearch.$inject = ['$resource'];

    function CompendiumSpecialPriceSearch($resource) {
        var resourceUrl =  'api/_search/compendium-special-prices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
